var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-input"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.options.name}},[_vm._v("\n      "+_vm._s(_vm.options.label)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 p-2"},[_c('div',[_vm._v(_vm._s(_vm.value))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8416eb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/DisplayInput.vue
// module id = 896
// module chunks = 1